import * as prismic from '@prismicio/client';

const repositoryName = 'knas-website';

export const client = prismic.createClient(repositoryName);

